import { render, staticRenderFns } from "./Pos_add_promotion.vue?vue&type=template&id=a59d6878&scoped=true&"
import script from "./Pos_add_promotion.vue?vue&type=script&lang=js&"
export * from "./Pos_add_promotion.vue?vue&type=script&lang=js&"
import style0 from "./Pos_add_promotion.vue?vue&type=style&index=0&id=a59d6878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59d6878",
  null
  
)

export default component.exports